import pendo, { LEARNER_API_KEY } from 'js/lib/pendo';
import { get as getUser } from 'js/lib/user';

import persistingCounter from 'bundles/ai-course-coach/utils/persistingCounter';
import { captureMessageInSentry } from 'bundles/ai-course-coach/utils/sentryUtils';

const COACH_PENDO_GUIDE_ID = 'xlZ3K463HTVW4_w8Go4tWDBJtP8';
let coachPendoTriggerInstance: ReturnType<typeof coachPendoTrigger>;

function coachPendoTrigger({
  triggerMessageCount,
  triggerOpenCount,
}: {
  triggerMessageCount: number;
  triggerOpenCount: number;
}) {
  const openCounter = persistingCounter('coach-open-count-pendo', 0);
  const messageCounter = persistingCounter('coach-message-count-pendo', 0);
  const setComplete = () => {
    openCounter.set(-1);
    messageCounter.set(-1);
  };

  try {
    const { external_id: externalId, is_staff: isStaff, is_superuser: isSuperuser } = getUser();
    pendo.init(
      {
        visitor: {
          id: externalId,
          isStaff,
          isSuperuser,
        },
      },
      LEARNER_API_KEY
    );
  } catch (e) {
    captureMessageInSentry({ error: e, source: 'pendo' });
  }

  const isComplete = (): boolean => {
    return openCounter.get() === -1 && messageCounter.get() === -1;
  };

  const conditionalTriggerPendo = async () => {
    const completed = isComplete();
    if (completed) {
      return;
    }

    const openCount = openCounter.get();
    const messageCount = messageCounter.get();
    if (openCount >= triggerOpenCount && messageCount >= triggerMessageCount) {
      // enable pendo
      try {
        pendo.showGuideById(COACH_PENDO_GUIDE_ID);
        setComplete();
      } catch (error) {
        captureMessageInSentry({ error });
      }
    }
  };

  const handleIncrement = (callback: () => void) => () => {
    if (isComplete() === false) {
      callback();
    }
  };

  return {
    messageIncrement: handleIncrement(messageCounter.increment),
    openIncrement: handleIncrement(openCounter.increment),
    conditionalTriggerPendo,
    handleNewMessage: () => {
      messageCounter.increment();
      conditionalTriggerPendo();
    },
  };
}

// removing interface props This singleton is now only temporary and will be removed ASAP as we move toward platformizing coach.
// we do not want to have pendo as a platform feature. (until further notice)
export default function getCoachPendoTrigger() {
  if (!coachPendoTriggerInstance) {
    coachPendoTriggerInstance = coachPendoTrigger({ triggerMessageCount: 6, triggerOpenCount: 0 });
  }
  return coachPendoTriggerInstance;
}
